import React, { useState } from 'react';

const BlogManager = ({ seminar, onSave }) => {
    const photos = seminar.blogPhotos || [];
    const [shareLinkCopied, setShareLinkCopied] = useState(false);

    const handleDeleteImage = (idToDelete) => {
        const newPhotos = photos.filter(photo => photo.id !== idToDelete);
        onSave({ ...seminar, blogPhotos: newPhotos });
    };

    const handleDownloadAll = () => {
        photos.forEach((photo, index) => {
            const link = document.createElement('a');
            link.href = photo.src;
            link.download = `${seminar.blogName || 'seminar'}_photo_${index + 1}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const handleShareLink = () => {
        const shareableLink = `${window.location.href.split('?')[0]}?view=seminar&id=${seminar.id}`;
        const textArea = document.createElement("textarea");
        textArea.value = shareableLink;
        textArea.style.position = "fixed"; 
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            setShareLinkCopied(true);
            setTimeout(() => setShareLinkCopied(false), 2000);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
        document.body.removeChild(textArea);
    };

    return (
        <div className="max-w-4xl mx-auto p-4">
            <div className="flex justify-between items-center mb-4">
                 <h2 className="text-xl font-bold">Gérer les photos du blog : {seminar.blogName}</h2>
                 <div className="flex gap-2">
                    <button onClick={handleDownloadAll} className="bg-[#22D6B5] text-white font-bold py-2 px-4 rounded-lg hover:bg-opacity-90">
                        Télécharger tout
                    </button>
                    <button onClick={handleShareLink} className="bg-[#F2507B] text-white font-bold py-2 px-4 rounded-lg hover:bg-opacity-90 relative">
                        {shareLinkCopied ? 'Lien copié !' : 'Générer un lien de partage'}
                    </button>
                 </div>
            </div>
            {photos.length > 0 ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {photos.map((photo) => (
                        <div key={photo.id} className="relative group bg-gray-100 rounded-lg shadow-md">
                            <img src={photo.src} alt={`Blog photo ${photo.id}`} className="w-full h-40 object-cover rounded-lg" />
                             {photo.liked && (
                                <svg className="w-5 h-5 text-red-500 absolute bottom-2 left-2" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd"></path></svg>
                            )}
                            <button 
                                onClick={() => handleDeleteImage(photo.id)} 
                                className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm4 0a1 1 0 012 0v6a1 1 0 11-2 0V8z" clipRule="evenodd"></path></svg>
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                 <div className="text-center py-16 px-6 bg-gray-100 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-700">Le blog est vide</h3>
                    <p className="text-gray-500 mt-2">Ajoutez des photos pour commencer à remplir le blog.</p>
                 </div>
            )}
        </div>
    );
};

export default BlogManager;